import moment from 'moment';
import { SET_TYPE_PROFIL, SET_TYPE_CONDITION, SET_MULTIMODAL, SET_TYPE_DATE, SET_TIME } from '../actions/profilActions';

const initialState = {
  profil: 'Déficience motrice',
  condition: 'Fauteuil roulant manuel',
  multimodal: true,
  type_date: 1,
  time: moment()
};

const profilReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TYPE_PROFIL: 
      return {...state, profil: action.payload};
    case SET_TYPE_CONDITION: 
      return {...state, condition: action.payload};
    case SET_MULTIMODAL: 
      return {...state, multimodal: action.payload};
    case SET_TYPE_DATE:
      return {...state, type_date: action.payload};
    case SET_TIME:
      return {...state, time: action.payload};
    default: return state;
  }
};

export default profilReducer;
